// extracted by mini-css-extract-plugin
export default {"content":"ManageAdmins_content__46UHZ"};